import { createSlice } from "@reduxjs/toolkit";

import { ACCOUNT_TYPE } from "../../../constants/app_constants";

const initialState = {
  isEdit: false,
  createForm: { fullname: "" },
  updateForm: { id: "", fullname: "" },
  updateAccountForm: {
    memberId: "",
    accountNo: "",
    accountName: "",
    bankName: "",
  },
  createFormMember: {
    username: "",
    password: "",
    passwordConfirm: "",
    nickname: "",
    customerOf: null,
    isTestUser: false,
  },
  updateFormMemberLevel: {
    member: null,
    level: null,
  },
  resetPassword: { member: null, newPassword: null, username: null },
  resetWithdrawPassword: { member: null, newPassword: null },
  isOpenMemberModal: false,
  isOpenUpdateAccountModal: false,
  isOpenLevelModal: false,
  isBugOpen: null,
  isEnableCrobJob: null,
  isOpenPasswordModal: false,
  isOpenWithdrawPasswordModal: false,
  isOpenIdentityModal: false,
  identity: {
    id: "",
    cardName: "",
    cardNo: "",
    cardImageUrl: "",
    isVerified: false,
  },
};

const managementSlice = createSlice({
  name: "management",
  initialState,
  reducers: {
    // staff
    setUpdateStaff: (state, { payload }) => {
      state.isEdit = true;
      state.updateForm = { id: payload.id, fullname: payload.fullname };
    },
    onChangeStaff: (state, { payload }) => {
      if (state.isEdit) {
        state.updateForm.fullname = payload.fullname;
      } else {
        state.createForm.fullname = payload.fullname;
      }
    },
    clearFormStaff: (state) => {
      state.isEdit = initialState.isEdit;
      state.createForm = initialState.createForm;
      state.updateForm = initialState.updateForm;
    },
    // member
    onChangeMember: (state, action) => {
      state.createFormMember = {
        ...state.createFormMember,
        username: action.payload.username,
        password: action.payload.password,
        passwordConfirm: action.payload.passwordConfirm,
        nickname: action.payload.nickname,
        customerOf: action.payload.customerOf,
        isTestUser: action.payload.isTestUser,
      };
    },
    onChangeAccount: (state, action) => {
      state.updateAccountForm = {
        ...state.updateAccountForm,
        accountNo: action.payload.accountNo,
        accountName: action.payload.accountName,
        bankName: action.payload.bankName,
        cryptoAddress: action.payload.cryptoAddress,
        cryptoNetwork: action.payload.cryptoNetwork,
      };
    },
    clearFormMember: (state) => {
      state.createFormMember = initialState.createFormMember;
    },
    setUpdateAccount: (state, action) => {
      state.updateAccountForm = {
        memberId: action.payload.memberId,
        accountNo: action.payload.accountNo,
        accountName: action.payload.accountName,
        bankName: action.payload.bankName,
        updatedAccount: action.payload.updatedAccount,
        cryptoAddress: action.payload?.crypto?.address,
        cryptoNetwork: action.payload.crypto?.network,
        accountType: action.payload?.accountType ?? ACCOUNT_TYPE.BANK,
      };
    },
    setResetPassword: (state, { payload }) => {
      state.resetPassword = {
        member: payload.member,
        username: payload.username,
      };
    },
    setResetWithdrawPassword: (state, { payload }) => {
      state.resetWithdrawPassword = {
        member: payload.member,
      };
    },
    handleChangeResetPassword: (state, { payload }) => {
      state.resetPassword = {
        ...state.resetPassword,
        newPassword: payload.newPassword,
        username: payload.username,
      };
    },
    handleChangeResetWithdrawPassword: (state, { payload }) => {
      state.resetWithdrawPassword = {
        ...state.resetWithdrawPassword,
        newPassword: payload.newPassword,
      };
    },
    clearFormAccount: (state) => {
      state.updateAccountForm = initialState.updateAccountForm;
    },
    clearSelectedStaff: (state) => {
      state.createFormMember.customerOf = null;
    },
    setUpdateMemberLevel: (state, action) => {
      state.updateFormMemberLevel = {
        member: action.payload.member,
        level: action.payload.level,
      };
    },
    onChangeMemberLevel: (state, { payload }) => {
      state.updateFormMemberLevel.level = payload;
    },
    clearFormMemberLevel: (state) => {
      state.updateFormMemberLevel = initialState.updateFormMemberLevel;
    },
    toggleMemberModal: (state) => {
      state.isOpenMemberModal = !state.isOpenMemberModal;
    },
    toggleUpdateAccountModal: (state) => {
      state.isOpenUpdateAccountModal = !state.isOpenUpdateAccountModal;
    },
    toggleLevelModal: (state) => {
      state.isOpenLevelModal = !state.isOpenLevelModal;
    },
    toggleOpenBug: (state, { payload }) => {
      state.isBugOpen = payload;
    },
    toggleEnableCronJob: (state, { payload }) => {
      state.isEnableCrobJob = payload;
    },
    togglePasswordModal: (state) => {
      state.isOpenPasswordModal = !state.isOpenPasswordModal;
    },
    toggleWithdrawPasswordModal: (state) => {
      state.isOpenWithdrawPasswordModal = !state.isOpenWithdrawPasswordModal;
    },
    toggleIdentityModal: (state) => {
      state.isOpenIdentityModal = !state.isOpenIdentityModal;
    },
    setIdentity: (state, { payload }) => {
      state.identity = payload;
    },
  },
});

export const {
  setUpdateStaff,
  onChangeStaff,
  clearFormStaff,
  onChangeMember,
  onChangeAccount,
  clearFormMember,
  setUpdateAccount,
  clearFormAccount,
  clearSelectedStaff,
  setUpdateMemberLevel,
  onChangeMemberLevel,
  clearFormMemberLevel,
  toggleMemberModal,
  toggleUpdateAccountModal,
  toggleLevelModal,
  toggleOpenBug,
  toggleEnableCronJob,
  togglePasswordModal,
  setResetPassword,
  handleChangeResetPassword,
  toggleIdentityModal,
  setIdentity,
  setResetWithdrawPassword,
  toggleWithdrawPasswordModal,
  handleChangeResetWithdrawPassword,
} = managementSlice.actions;

export default managementSlice.reducer;
